import { OnInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { IFilterComponent, SearchFilter } from '../../../../../infrastructure/iFilter-component';
import { LogisticsService } from '../../../../../services/logistics.service';
import { FilterRecordService } from '../../../../../services/filter-record.service';
import { PatientSearch } from '../../../../../model/patient/patient-search';
import { NotificationToastService } from '../../../../../services/notification-toast.service';


@Component({
  selector: 'study-report-delivery-filter',
  templateUrl: './study-report-delivery-filter.component.html',
  styleUrls: ['./study-report-delivery-filter.component.css']
})
export class StudyReportDeliveryFilterComponent implements IFilterComponent  {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;

  constructor(private formBuilder: FormBuilder
    , private logisticsService: LogisticsService
    , private notificationToastService: NotificationToastService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      Protocol: [''],
      Patient: [null],
      ShowAll: [false],
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('StudyReportDeliveryFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('StudyReportDeliveryFilterComponent', this.form);
  }

  async search(): Promise<any> {
    if (this.form.controls.Protocol.value || this.form.controls.Patient.value) {
      return await this.logisticsService.getStudyReportDeliverySearchItems(
        <boolean>(this.form.controls.ShowAll.value ?  this.form.controls.ShowAll.value : false)
        , this.form.controls.Protocol.value
        , (this.form.controls.Patient.value ? (<PatientSearch>this.form.controls.Patient.value).Id : null));
    } else {
      this.notificationToastService.error('Por favor ingrese criterio de búsqueda', 'Entraga de estudios');
    }
  }
}
